var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMuteIcon = function SvgMuteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "#848484"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.12 7.706a.99.99 0 0 1 .574.895v13.797a.986.986 0 0 1-1.627.75l-4.323-3.706H6.48a2.3 2.3 0 0 1-2.3-2.3v-3.285a2.3 2.3 0 0 1 2.3-2.3h2.264l4.322-3.705a.99.99 0 0 1 1.053-.146m-5.523 7.888c-.178.154.31 3.107.767.548L6.48 13.529a.33.33 0 0 0-.328.328L9 15.937c0 .182 0 0 .254.533l-.273-.054c-.074-2.205-.88-2.058.273.054zm12.136-7.53a.985.985 0 0 1 1.393 0 10.51 10.51 0 0 1 0 14.868.985.985 0 0 1-1.393-1.393 8.543 8.543 0 0 0 0-12.08.985.985 0 0 1 0-1.394m-1.393 2.788a.986.986 0 1 0-1.394 1.394 4.6 4.6 0 0 1 0 6.504.986.986 0 1 0 1.393 1.393 6.57 6.57 0 0 0 0-9.29z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "m6.955 12.802-1.15.603.164 2.682 2.19 2.135 2.355-.164.602-3.778z"
  })));
};
export { SvgMuteIcon as ReactComponent };
export default __webpack_public_path__ + "images/mute-icon.svg";